import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=6a824de5&"
import script from "./ImageModal.vue?vue&type=script&lang=js&"
export * from "./ImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImageModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/ImageModal.vue
// module id = 1660
// module chunks = 1